import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import {
  viewS3FileDocument,
  downloadFileCommon,
  downloadFileBinary,
  printFileCommon,
} from "src/common/utils/app.s3";
import { showNotification } from "src/common/utils/app.util";

export const importFile = (apiEndpoint: string, formData: any) => async (dispatch: any) => {
  try {
    const result = await ax.post<IApi>(apiEndpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (!result.data.success) {
      throw new Error(result.data.error || result.statusText);
    }
    if (result.status === 200 && result.data.success) {
      return result.data;
    }
  } catch (error: any) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const viewFile = (apiEndpoint: string, data: any) => async (dispatch: any) => {
  try {
    const res = await ax.get<IApi>(apiEndpoint, { responseType: "blob" });
    if (res.status === 200) {
      viewS3FileDocument(res.data);
    } else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const getPrintFile = (data: any, dispatch: any) => async (dispatch: any) => {
  printFileCommon(data, dispatch);
  return;
};

export const downloadFile = (data: any) => async (dispatch: any) => {
  dispatch(
    addNotificationAction({
      message: "Your download will begin shortly",
      options: { variant: "success" },
    })
  );
  downloadFileCommon(data);
  return;
};

export const downloadBinary = (data: any) => async (dispatch: any) => {
  dispatch(
    addNotificationAction({
      message: "Your download will begin shortly",
      options: { variant: "success" },
    })
  );
  downloadFileBinary(data);
  return;
};

export const searchData = (apiEndpoint: string, body: any) => async (dispatch: any) => {
  try {
    const result = await ax.post<IApi>(apiEndpoint, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.data.isSuccess === true) {
      return result.data.value;
    } else throw new Error(result?.data?.error || "Error");
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};
export const searchDataWithGet = (apiEndpoint: string) => async (dispatch: any) => {
  try {
    const result = await ax.get<IApi>(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.status === 200 && result.data.success) {
      return result.data;
    } else throw new Error(result?.data?.error || "Error");
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const submitFormData = (apiEndpoint: string, body: any) => async (dispatch: any) => {
  try {
    const result: any = await ax.post<IApi>(apiEndpoint, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.data.isSuccess) {
      // dispatch(
      //   addNotificationAction({
      //     message: message,
      //     options: { variant: "success" },
      //   })
      // );
      return result.data.value;
    } else throw new Error(result?.error || "Error");
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};
export const AddData =
  (apiEndpoint: string, messageText: string, body: any) => async (dispatch: any) => {
    try {
      const result = await ax.post<IApi>(apiEndpoint, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (result.status === 200 && result.data.success) {
        dispatch(
          addNotificationAction({
            message: messageText,
            options: { variant: "success" },
          })
        );
        return result.data;
      } else throw new Error(result?.data?.error || "Error");
    } catch (error) {
      if (error instanceof Error) showNotification(error.message, "error", dispatch);
      throw error;
    }
  };
